import React from 'react';
import {view, Divider} from '@sail/ui';

interface BaseCardProps {
  header: React.ReactNode;
  children: React.ReactNode;
  showDivider?: boolean;
}

export const BaseCard: React.FC<BaseCardProps> = ({
  header,
  children,
  showDivider = true,
}) => {
  return (
    <view.div
      css={{
        stack: 'y',
        borderRadius: 'small',
        borderColor: 'border',
        borderWidth: 'small',
        borderStyle: 'solid',
      }}
    >
      {/* Header Section */}
      <view.div
        css={{
          stack: 'x',
          padding: 'space.150',
          alignItems: 'center',
          distribute: 'space-between',
        }}
      >
        {header}
      </view.div>

      {showDivider ? <Divider css={{paddingTop: '0.5px'}} /> : null}

      {/* Content */}
      <view.div
        css={{
          stack: 'y',
          gapY: 'space.150',
          paddingY: 'medium',
          paddingX: 'space.150',
        }}
      >
        {children}
      </view.div>
    </view.div>
  );
};
